import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import EditIcon from "../../../../Icons/EditIcon";
import DuplicateIcon from "../../../../Icons/DuplicateIcon";
import PreviewIcon from "../../../../Icons/PreviewIcon";
import CancelIcon from "../../../../Icons/CancelIcon";
import ArchiveIcon from "../../../../Icons/ArchiveIcon";
import PublishIcon from "../../../../Icons/PublishIcon";
import ScheduleIcon from "../../../../Icons/ScheduleIcon";

const ActionBox = ({ classes, showActionBox, data, ...rest }) => {
  const {
    onEditClickedCallback,
    onDuplicateClickedCallback,
    onCancelClickedCallback,
    onArchiveClickedCallback,
    onPreviewClickedCallback,
    onUnarchiveClickedCallback,
    onPublishClickedCallback,
  } = rest;

  const renderUnarchiveButtons = () => {
    return (
      <>
        {/* Publish button */}
        {data.status === "publish_scheduled" && (
          <Box
            className={classes.singleEntryButtonWrapper}
            onClick={() => onPublishClickedCallback(data, true)}
          >
            <PublishIcon viewBox="0 0 24 24" className={classes.publishIcon} />
            <Typography className={classes.buttonText} noWrap>
              Publish
            </Typography>
          </Box>
        )}

        {/* Schedule Invite button */}
        {data.status === "published" && (
          <Box
            className={classes.singleEntryButtonWrapper}
            onClick={() => onPublishClickedCallback(data, false)}
          >
            <ScheduleIcon
              viewBox="0 0 24 24"
              className={classes.scheduleIcon}
            />
            <Typography className={classes.buttonText} noWrap>
              Schedule Invite
            </Typography>
          </Box>
        )}

        {/* Edit & Preview buttons */}
        {data.status !== "canceled" && (
          <>
            <Box
              className={classes.singleEntryButtonWrapper}
              onClick={() => onEditClickedCallback(data)}
            >
              <EditIcon
                viewBox="0 0 16 16"
                className={classes.editIcon}
                style={{ width: 24 }}
              />
              <Typography className={classes.buttonText} noWrap>
                Edit
              </Typography>
            </Box>
            <Box
              className={classes.singleEntryButtonWrapper}
              onClick={() => onPreviewClickedCallback(data)}
            >
              <PreviewIcon
                viewBox="0 0 18 12"
                className={classes.previewIcon}
                style={{ width: 24 }}
              />
              <Typography className={classes.buttonText} noWrap>
                Preview
              </Typography>
            </Box>
          </>
        )}

        {/* Duplicate button */}
        <Box
          className={classes.singleEntryButtonWrapper}
          onClick={() => onDuplicateClickedCallback(data)}
        >
          <DuplicateIcon
            viewBox="0 0 15 17"
            className={classes.duplicateIcon}
            style={{ width: 24 }}
          />
          <Typography className={classes.buttonText} noWrap>
            Duplicate
          </Typography>
        </Box>

        {/* Cancel or Archive button */}
        {["published", "invited", "invite_scheduled"].includes(data.status) ? (
          <Box
            className={classes.singleEntryNegButtonWrapper}
            onClick={() => onCancelClickedCallback(data)}
          >
            <CancelIcon
              viewBox="0 0 18 18"
              className={classes.cancelIcon}
              style={{ width: 24 }}
            />
            <Typography className={classes.buttonText} noWrap>
              Cancel Event
            </Typography>
          </Box>
        ) : (
          <Box
            className={classes.singleEntryButtonWrapper}
            onClick={() => onArchiveClickedCallback(data)}
          >
            <ArchiveIcon
              viewBox="0 0 14 14"
              className={classes.archiveIcon}
              style={{ width: 24 }}
            />
            <Typography className={classes.buttonText} noWrap>
              Archive
            </Typography>
          </Box>
        )}
      </>
    );
  };

  const renderArchiveButtons = () => {
    return (
      <Box
        className={classes.singleEntryButtonWrapper}
        onClick={() => onUnarchiveClickedCallback(data)}
      >
        <ArchiveIcon
          viewBox="0 0 14 14"
          className={classes.archiveIcon}
          style={{ width: 24 }}
        />
        <Typography className={classes.buttonText} noWrap>
          Unarchive
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      className={classes.singleEntryActionsWrapper}
      style={{ display: showActionBox ? "flex" : "none" }}
    >
      {data.status !== "archived"
        ? renderUnarchiveButtons()
        : renderArchiveButtons()}
    </Box>
  );
};

export default ActionBox;
